export const PHONE_FORMAT = '(###) ###-####-###'
export const US_PHONE_FORMAT = '+1 (###) ###-####'
export const SHORT_FREQUENCY_OPTIONS = {
	daily: 'Dly',
	hourly: 'Hr',
	monthly: 'Mth',
	yearly: 'Yr',
	weekly: 'Wk',
}
export const OFFER_STATUSES = {
	offer_accepted: 'offer_accepted',
	offer_rejected: 'offer_rejected',
	offer_sent: 'offer_sent',
}

export const INTERVIEW_COMPLETED_STATUS = ['Interview Passed', 'Interview Failed', 'Interview Completed']

export const PROFILE_STEP_SUBTITLE = {
	nurse_license: 'CLINICAL_EXPERIENCE',
	nurse_experience: 'PROFESSIONAL_EXPERIENCE',
	nurse_relocation: 'IMMIGRATION',
	nurse_license_without_nclex: 'CLINICAL_EXPERIENCE',
	nurse_experience_without_nclex: 'PROFESSIONAL_EXPERIENCE',
	nurse_relocation_without_nclex: 'IMMIGRATION',
}
